const isBrowser = typeof document !== 'undefined';

export const setCookie = (name, value, maxAgeSeconds = 60 * 60 * 24 * 7) => {
  if (!isBrowser || value == null) return;

  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(String(value))}; Path=/; Max-Age=${maxAgeSeconds}; SameSite=Lax${secure}`;
};

export const getCookie = (name) => {
  if (!isBrowser) return null;

  const encodedName = encodeURIComponent(name);
  const match = document.cookie.match(new RegExp(`(?:^|; )${encodedName}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
};

export const removeCookie = (name) => {
  if (!isBrowser) return;
  document.cookie = `${encodeURIComponent(name)}=; Path=/; Max-Age=0; SameSite=Lax`;
};

export default { setCookie, getCookie, removeCookie };
